import { Gauge, Wrench, Map } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ctaGo } from "./scroll";

const ITEMS = [
  {
    icon: Gauge,
    title: "Your rate, against the market",
    copy: "We check the rate you're paying against what lenders are offering borrowers like you today — and show you the gap in dollars.",
  },
  {
    icon: Wrench,
    title: "Fees and features",
    copy: "Offset, redraw, penalty-free extra repayments — we make sure you're not paying for features you don't use, or missing ones you need.",
  },
  {
    icon: Map,
    title: "A plan to pay it off sooner",
    copy: "A sharper rate, the right structure or small extra repayments — you get a plan that can shave years off your home loan.",
  },
];

const LoanReview = () => (
  <section id="loan-review" className="relative overflow-hidden bg-mint py-24 text-ink lg:py-32">
    <div className="mx-auto max-w-[88rem] px-6 lg:px-12">
      <Reveal>
        <Eyebrow>Free annual home loan review</Eyebrow>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Rates move. Your loan
          <span className="italic text-eucalyptus"> should too.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg">
          Every twelve months we put your loan back against the market —
          lenders count on borrowers not noticing. If a refinance home loan
          would do better, we show you the numbers before you decide. If your
          loan is still right, we tell you that too.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
        {ITEMS.map((it, i) => (
          <Reveal key={it.title} delay={0.08 * i}>
            <div className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-28px_rgba(52,59,65,0.35)]" data-testid={`review-card-${i + 1}`}>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-ink/10 text-eucalyptus">
                <it.icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <h3 className="mt-6 font-display text-2xl font-medium text-ink">{it.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-ink/65">{it.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <a
            href="tel:0414345736"
            onClick={ctaGo}
            data-testid="review-cta-call"
            className="group inline-flex items-center justify-center gap-3 rounded-full bg-ink px-8 py-4 text-sm font-semibold text-ivory transition-all duration-300 hover:-translate-y-0.5 hover:bg-eucalyptus hover:text-ivory"
          >
            See how my loan stacks up
          </a>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink/55">
            Free · one conversation · no obligation
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default LoanReview;
